import AvailabilityResponse from './AvailabilityResponse';

export enum CurrentWipStatus {
  Unknown = 'Unknown',
  VehicleInspection = 'VehicleInspection',
  ReconditioningAndDetailing = 'ReconditioningAndDetailing',
  Kicked = 'Kicked'
}

type Availability = Omit<
  AvailabilityResponse,
  'dealerPurchaseInitiatedByUserId' | 'isDealerPurchased'
> & {
  isPendingDealerPurchase: boolean;
  isPendingDealerPurchaseByUser: boolean;
};

export default Availability;
